import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ManagePeopleActionsProps } from '../ManagePeopleActions/ManagePeopleActions.component';
import EnterpriseContext from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/providers/Enterprise/Enterprise.context';
import EmptyStateImage from 'assets/images/documents-ilustration.webp';
import { ManagePeopleActions } from '../ManagePeopleActions';
import ResolveImage from 'components/ResolveImage';

import './ManagePeopleEmptyState.styles.scss';
import './ManagePeopleEmptyState.styles.responsive.scss';

type ManagePeopleEmptyStateProps = {
  className?: string;
} & ManagePeopleActionsProps;

const ManagePeopleEmptyState: React.FC<ManagePeopleEmptyStateProps> = (
  props,
) => {
  const { className, ...rest } = props;

  const { enterprise } = useContext(EnterpriseContext);
  const { brandName } = enterprise || {};

  const classes = classNames(
    'manage-people-empty-state',
    'white-panel',
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage
        src={EmptyStateImage}
        asIllustration
        alt="There are no people"
      />
      <p>{t('thereAreNoPeopleFor', { brandName })}</p>
      <ManagePeopleActions {...rest} />
    </div>
  );
};

export default ManagePeopleEmptyState;
